import React from 'react'
import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material'
import YouTubeIcon from "@mui/icons-material/YouTube";
// import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
    const theme = useTheme();
    return (
        <Grid sx={{ width: '100%' }} >
            <Box sx={{
                backgroundColor: "var(--primary-dark)",
                borderTop: '4px solid var(--secondary-color)',
                boxShadow: '0 -4px 20px rgba(0,0,0,0.1)'
            }}>

                <Grid
                    container
                    sx={{
                        px: { xs: 3, md: 6 },
                        py: { xs: 4, md: 5 },
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "space-between",
                    }}
                >
                    <Grid
                        item
                        md={8}
                        xs={12}
                        sm={6}
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: { xs: 'center', md: 'flex-start' },
                                textAlign: { xs: 'center', md: 'left' },
                                gap: 1,
                                width: '100%',
                                py: { xs: 1, md: 0 },
                            }}
                        >
                            <Typography variant="body1" sx={{ color: "rgba(255, 255, 255, 0.9)", fontSize: '1.1rem', fontWeight: 300, letterSpacing: '0.5px' }}>
                                © 2026 Top PU Colleges. All Rights Reserved.
                            </Typography>

                        </Box>
                    </Grid>
                    <Grid
                        item
                        md={4}
                        xs={12}
                        sm={6}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: { xs: "center", md: "flex-end", sm: "flex-end" },
                            gap: 2,
                            pt: { xs: 3, sm: 0 },
                            color: "#FFF",
                        }}
                    >
                        <Typography sx={{ fontWeight: 500, mr: 1, color: 'rgba(255,255,255,0.8)' }}> Follow us:</Typography>

                        {[
                            { icon: <FacebookIcon fontSize="large" />, url: "https://www.facebook.com/" },
                            { icon: <InstagramIcon fontSize="large" />, url: "https://www.instagram.com/getmycollege_/" },
                            { icon: <TwitterIcon fontSize="large" />, url: "https://twitter.com/" },
                            { icon: <YouTubeIcon fontSize="large" />, url: "#" },
                            { icon: <WhatsAppIcon fontSize="large" />, url: "https://api.whatsapp.com/send?phone=7760001516" },
                        ].map((social, index) => (
                            <Box
                                key={index}
                                onClick={() => social.url !== '#' && (window.location.href = social.url)}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: "45px",
                                    width: "45px",
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255,255,255,0.1)",
                                    color: "#FFF",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "var(--secondary-color)",
                                        transform: "translateY(-3px)",
                                        boxShadow: "0 5px 15px rgba(255, 87, 34, 0.4)"
                                    }
                                }}
                            >
                                {social.icon}
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

export default Footer
